import styled from 'styled-components'

import layout from 'constants/layout'

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  row-gap: 16px;
`

interface StyledRowProps {
  $doubleColumn?: boolean
}

export const StyledRow = styled.div<StyledRowProps>`
  ${({ $doubleColumn }) => $doubleColumn && `
    grid-column: span 2;
  `}

  @media (max-width: ${layout.mobileWidthResolution}px) {
    grid-column: span 2;
  }
`
